/**
 * @createdBy:HuangJian
 * @date:2018/12/1
 * @description：
 *
 * directives 下存放所有的公共指令
 */

var directives = {};

/**
 * @name：readonlyAll
 * @description：全局只读指令，将旗下的input都设置为只读。
 */
directives.readonlyAll = {

    update: function (el, binding, vnode, oldVnode) {
        for(let i=0; i<el.getElementsByTagName('input').length; i++){
            el.getElementsByTagName('input')[i].readOnly=true;
            el.getElementsByTagName('input')[i].disabled=true;

        }
        for(let i=0; i<el.getElementsByTagName('button').length; i++){
            el.getElementsByTagName('button')[i].disabled=true;
        }
    }
};
/**
 * @name：readonlyAll
 * @description：按钮点击延时指令，按钮点击以后指定的时间后才可以再次点击
 */

directives.delay = {

    update: function (el, binding, vnode, oldVnode) {
        el.addEventListener('click', function(){
            el.disabled=true;
            el.style.opacity='0.4';
            setTimeout(function() {
                el.disabled=false;
                el.style.opacity='1';
            }, 1000);
        }, true);
    }
};


/**
 * @createdBy:HuangJian
 * @date:2018/12/1
 * @description：指令安装函数（勿动）
 */

const install = (vue) => {
    for(var key in directives){
        vue.directive(key, directives[key]);
    }
};

export default {install};
